import * as React from "react";
import { useState, useImperativeHandle, useCallback, useMemo } from "react";
import { MenuItem, Button, Modal } from "components/bootstrap";
import ModalButtonToolbar from "components/common/ModalButtonToolbar";
import useInvestigationPanel from "security-app/components/Investigations/hooks/useInvestigationPanel";
import { useAddEvidence } from "security-app/hooks/useInvestigationsAPI";
import useActionCondition from "security-app/components/Investigations/plugin/useActionCondition";
import useSearchSrvc from "./shared/useSearchSrvc";
import AddEvidenceModal from "./shared/AddEvidenceModal";
export const SearchInvestigationsModal = React.forwardRef(
  ({ search }, ref) => {
    const { isSearchRelative, saveAsAbsoluteSearch } = useSearchSrvc(search);
    const isAvailable = useActionCondition();
    if (!isAvailable) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(
      AddEvidenceModal,
      {
        ids: [search.id],
        type: "searches",
        searchMeta: { searchTitle: search.title, isSearchRelative, saveAsAbsoluteSearch },
        ref
      }
    );
  }
);
export const AddSearchConfirmationDialog = React.forwardRef(
  ({ search }, ref) => {
    const [showModal, setShowModal] = useState(false);
    const isAvailable = useActionCondition();
    const { addEvidence } = useAddEvidence();
    const { saveAsAbsoluteSearch } = useSearchSrvc(search);
    const { selectedInvestigationId } = useInvestigationPanel();
    useImperativeHandle(ref, () => ({
      toggle: () => setShowModal(true)
    }));
    const onSaveAs = useCallback(
      (timeRangeType) => async () => {
        setShowModal(false);
        const newSearch = timeRangeType === "absolute" ? await saveAsAbsoluteSearch(`Absolute - ${search.title}`) : search;
        await addEvidence({
          invId: selectedInvestigationId,
          payload: { searches: [newSearch.id] }
        });
      },
      [saveAsAbsoluteSearch, selectedInvestigationId, search, addEvidence]
    );
    const onCancel = useCallback(() => {
      setShowModal(false);
    }, []);
    const buttons = useMemo(
      () => /* @__PURE__ */ React.createElement(ModalButtonToolbar, null, /* @__PURE__ */ React.createElement(Button, { onClick: onCancel }, "Cancel"), /* @__PURE__ */ React.createElement(Button, { onClick: onSaveAs("relative") }, "Save as Relative"), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: onSaveAs("absolute") }, "Save as Absolute")),
      [onCancel, onSaveAs]
    );
    if (!isAvailable) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(Modal, { show: showModal, onHide: onCancel, isConfirmDialog: true }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, "Relative search as evidence")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement("div", null, "The search you are trying to add is relative to the current time. This means that the results will change.", /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("br", null), "Would you like to make an absolute copy of this search and add it to the investigation?")), /* @__PURE__ */ React.createElement(Modal.Footer, null, buttons));
  }
);
const CoreSearchActions = ({ loaded, modalRefs = void 0 }) => loaded ? /* @__PURE__ */ React.createElement(MenuItem, { icon: "extension", onClick: () => {
  var _a, _b;
  return (_b = (_a = modalRefs == null ? void 0 : modalRefs.searchInvestigationsModal) == null ? void 0 : _a.call(modalRefs)) == null ? void 0 : _b.toggle();
} }, "Add to investigation") : null;
export default CoreSearchActions;
